module.exports = __webpack_public_path__ + "img/cropimage3431.33c7d2e2.webp";